module.exports = __webpack_public_path__ + "img/img_map.0b6ddb8a.png";